export enum CellStatus {
  main = 'main',
  merged = 'merged',
}

export type CellWithMergedRows = {
  cellId: string;
  mergedCellsCount: number;
  status: CellStatus;
};

export type CellsWithMergesRows = {
  cellMerges?: CellWithMergedRows[];
  id: string;
};
